var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import classNames from 'classnames';
import { Icon } from '../../Icon';
import { Typography } from '../../Typography';
import "./styles.css";
export var Label = forwardRef(function (_a, ref) {
    var _b = _a.type, type = _b === void 0 ? 'default' : _b, assign = _a.assign, _c = _a.variant, variant = _c === void 0 ? 'outline' : _c, title = _a.title, iconName = _a.iconName, className = _a.className, props = __rest(_a, ["type", "assign", "variant", "title", "iconName", "className"]);
    // Обратная совместимость, атрибут variant как в Material UI
    if (assign) {
        console.warn('В компоненте Label вместо параметра assing используйте variant, assing в будущем будет удален.');
    }
    var optionedVariant = assign || variant;
    var typographyVariant = optionedVariant === 'outline' ? 'body3' : 'subtitle3';
    return (React.createElement("div", __assign({}, props, { className: classNames('lk-ui_label', "lk-ui_label__" + optionedVariant, "lk-ui_label__" + type, iconName && "lk-ui_label__with-icon", !title && "lk-ui_label__without-title", className), ref: ref }),
        iconName && (React.createElement(Icon, { className: 'lk-ui_label-icon', iconName: iconName, size: 'medium' })),
        optionedVariant !== 'icon' && title && (React.createElement(Typography, { className: 'lk-ui_label-title', variant: typographyVariant }, title))));
});
